module.exports = __webpack_public_path__ + "static/img/investment-300x300.ac0d91fa.jpg";